// extracted by mini-css-extract-plugin
export default {"search":"SearchProject_search__PluEQ","searchIcon":"SearchProject_searchIcon__WTeo7","closeIcon":"SearchProject_closeIcon__6i1pV"};